export default "__VITE_ASSET__DRILYcwM__"